export default {
    title: 'Diet plan',
    auto: 'Auto creation',
    previewMacros: 'Preview macronutrients',
    findDislikes: 'Search foods that client dislikes',
    findDislikesDisclaimer: 'Searching is not accurate and might have false-positives (or false-negatives).',
    recipes: 'Diet plan recipes',
    share: 'Send by e-mail / Save as PDF',
    searchFor: 'Search for',
    autoDesc: 'Automatic diet plan creation',
    system: 'This is a system template and you cannot edit this. Copy it to a client or to a new template.',
    copyToTemplateTitle: 'Are you sure you want to save this as a template?',
    copyToTemplateText: 'An exact replica will be created which you can edit individually.',
    copyToAthleteTitle: 'Are you sure you want to copy this diet plan?',
    copyToAthleteText: 'An exact replica will be created which you can edit individually.',
    noCalories: {
        title: 'You have not inserted the calories and the nutrients for this diet plan.',
        cta: 'Complete the equations or edit manually!'
    },
    replaceCustomerFns: 'Replace height/weight with the client\'s data?',
    addToCustomer: 'Add to client',
    pasteWithoutClear: 'Paste without clearing',
    copyDay: 'Copy day',
    pasteDay: 'Paste day',
    clearDay: 'Clear day',
    copyMealType: 'Copy',
    pasteMealType: 'Paste',
    clearMealType: 'Clear',
    carbohydrationWarning: 'Carbohydration is enabled!',
    ketosisWarning: 'Ketosis is enabled!',
    veganWarning: 'Vegan plan is enabled!',
    fastingWarning: 'Fasting plan is enabled!',
    hideQuantitiesWarning: 'Quantity hiding is enabled. Quantities will be hidden in prints & the mobile app.',
    copyToTable: 'Copy table (for usage in word, excel)',
    mealType: 'Meal type',
    insulinUnits: 'Insulin units',
    recipeModal: {
        title: 'Recipe list in the diet plan',
        list: 'Recipe list',
        empty: 'There were no recipes found in this diet plan.'
    },
    equations: {
        exerciseWarning: 'The calories leave out the sports: they are the basal metabolic rate × 1.2.',
        missingDetails: 'To work out the calories, fill in: {fields}.',
        fieldNames: {
            sex: 'sex', age: 'age', height: 'height', weight: 'weight', fat: 'body fat',
            carbsPerKg: 'carbs per kg', proteinsPerKg: 'proteins per kg', fatsPerKg: 'fats per kg',
        },
        belowBmr: 'The calories are below the basal metabolic rate ({bmr} kcal).',
        title: 'Equations',
        bmr: 'Base Metabolism Rate (kcal)',
        kcal: 'Required energy (kcal)',
        exerciseLevels: {
            title: 'Επιλέξτε επίπεδο άσκησης',
            '13': '(1.00-1.39) Τυπικές καθημερινές δραστηριότητες (Οικιακά καθήκοντα, χαλαρό περπάτημα,\n' +
                '                  καθιστική εργασία)',
            '155': '(1.4-1.59) Χαμηλή δραστηριότητα, τυπικές καθημερινές δραστηριότητες και 30-60 λεπτά\n' +
                '                  καθημερινής μέτριας δραστηριότητας (περπάτημα με 5-7 χλμ. / Ώρα)',
            '17': '(1.6-1.89) Ενεργοί άνθρωποι, τυπικές καθημερινές δραστηριότητες συν 60 λεπτά\n' +
                '                  καθημερινής μέτριας δραστηριότητας',
            '19': '(1.9-2.5) Πολύ δραστήριοι, τυπικές καθημερινές δραστηριότητες συν τουλάχιστον 60\n' +
                '                  λεπτά καθημερινής μέτριας δραστηριότητας συν επιπλέον 60 λεπτά έντονης ή 120 λεπτά μέτριας\n' +
                '                  δραστηριότητας'
        },
        pal: {
            title: 'Manual PAL',
            range: 'Range: from {from} to {to}'

        },
        placeholder: {
            age: 'Insert the client\'s age',
            height: 'Insert the client\'s height in cm',
            weight: 'Insert the client\'s weight in kg',
            fat: 'Insert the client\'s fat in percentage (e.g. 10%)',
            fatPerKg: 'Fat per body weight kg',
            proteinsPerKg: 'Proteins per body weight kg',
            carbsPerKg: 'Carbs per body weight kg'
        },
        errors: {
            age: 'Age must be valid',
            height: 'Height must be valid',
            weight: 'Weight must be valid',
            fat: 'Fat percentage must be valid',
        },
        settings: {
            title: 'Settings',
            manualKcal: 'Manually kcal insertion?',
            advancedEq: 'Advanced equation? (Use exercise to define daily caloric intake)',
            manualBmr: 'Insert BMR manually?',
            exerciseFactor: 'Calculate caloric needs using exercise factor?',
        },
        goal: {
            title: 'Choose a goal',
            maintain: 'Maintain weight',
            add: 'Lose weight',
            lose: 'Add weight',
            kgLose: 'How many kgs to lose per month?',
            kgAdd: 'How many kgs to add per month?'
        },

        functions: {
            title: 'Choose equation',
            1: 'Harris & Benedict',
            2: 'Revised Harris & Benedict',
            3: 'Owen',
            4: 'Mifflin',
            5: 'Katch-McArdle',
            6: 'Cunningham',
            7: 'FAO/WHO/UNU'
        }
    },
    macroTab: {
        title: 'Macronutrients',
        daily: 'Daily split',
        dailyHint: 'Share of the day\'s calories.',
        perMeal: 'Goals per meal',
        perMealHint: 'Split each macronutrient across the meals, for per-meal goals on the plan.',
        perKgUnit: 'g/kg',
        sum: 'Total',
        totalNot100: 'The total is {total}%, it needs to be 100%.',
        mealsNot100: 'Each macronutrient needs to add up to 100% across the meals.',
        notANumber: 'Each percentage needs to be a number, 0 or more.',
        keto: 'Keto: fats ≥ 60%, carbs ≤ 10%.',
        ketoFats: 'At least 60% on keto.',
        ketoCarbs: 'At most 10% on keto.',
        fromPerKg: 'Worked out from the grams per kg in Equations.',
        noKcal: 'Fill in the calories in Equations to see the grams.',
        track: 'Enable tracking of micronutrients?',
        choose: 'Select which micronutrients to track in the meal modal.',
        general: 'General micronutrients',
        generalShort: 'General',
        trixopoulou: 'Micronutrients only in Trixopoulou food list',
        trixopoulouShort: 'Trixopoulou',
        usda: 'Micronutrients only in USDA food list',
        usdaShort: 'USDA',
        selection: 'Selection',
        goals: 'Goals',
        goal: 'Goal',
        noGoalsSet: 'No goals set yet',
        noGoalsHint: 'Add goals for the micronutrients you are tracking.',
        disabledTitle: 'Micronutrient tracking is disabled',
        disabledSubtitle: 'Enable tracking to pick micronutrients and set daily goals.',
        enableTracking: 'Enable tracking',
        disableTracking: 'Disable',
        addGoal: 'Add Goal',
        nutrient: 'Nutrient',
        selectNutrient: 'Select Nutrient',
        chooseNutrient: 'Choose nutrient...',
        goalKind: 'Kind',
        chooseKind: 'Choose kind...',
        min: 'Minimum',
        max: 'Maximum',
        between: 'Between',
        value: 'Value',
        fromTo: 'From / To',
        from: 'From',
        to: 'To',
        goalMet: 'Met',
        goalNotMet: 'Not met',
    },
    exerciseTab: {
        title: 'Exercise',
        warning: 'To choose sports, you have to enable the advanced equation.',
        warningCta: 'Change settings'
    },
    settingsTab: {
        title: 'Settings'
    },
    analysisTab: {
        title: 'Analysis'
    },
    notesTab: {
        insertToNotes: 'Add to notes',
        replaceWithTemplate: 'Replace notes',
        intro: 'Add notes to this diet plan which you can use during printing.',
        noTemplates: 'No note templates yet',
        noTemplatesText: 'Create templates under “Note templates” in your account.'
    },
    settings: {
        generalTitle: 'General',
        dietTypeTitle: 'Diet type',
        mealsTitle: 'Meals',
        optionsVsDays: 'Show <strong>options</strong> instead of days',
        mobileShare: 'Share to mobile app',
        mobileShareNoClient: 'Only available for plans that belong to a client',
        allowMcpEdits: 'Allow AI edits',
        hideQuantities: 'Hide quantities',
        newFreeType: 'Enable option-based free type',
        isVegan: 'Vegan',
        isFasting: 'Fasting',
        isKeto: 'Ketogenic diet',
        isInsulin: 'Insulin-dependent diabetes',
        insulinRatio: 'Grams of carbohydrate per unit of insulin. For 1:15, enter 15',
        insulinRatioWarning: 'Remember to set the insulin:carbohydrate ratio. Follow the client\'s physician\'s guidance on the ratio. You can find more in Pathisis\' guidelines for dietitians.',
        carbohydration: 'Carb loading',
        dayOfCarbohydration: 'Carb loading day',
        carbohydrationMissingWeight: 'Carb loading needs the client\'s weight.',
        carbohydrationMissingWeightCta: 'Add it here.',
        ketoSetup: 'Remember to set the macro split for ketosis',
        ketoSetupCta: 'in the macros tab.',
    },
    attributes: 'Attributes',
    creation: {
        title: 'What kind of diet plan do you want to create?',
        custom: {
            title: 'Customizable plan',
            text: '(A diet plan with equations, foods, analysis etc)',
        },
        free: {
            title: 'Free-text plan',
            text: '(A diet plan that iss text only)'
        }
    },

    mergeMeals: 'Merge meals',
    unmergeMeals: 'Unmerge meals',
    stopMerging: 'Stop merging',
    reverseTable: 'Reverse table (days as columns)',
    appearance: {
        title: 'Appearance',
        saveFailed: "Couldn't save the appearance. Try again.",
        gridTheme: {
            label: 'Table theme',
            original: 'Original',
            refreshed: 'Refreshed',
            tinted: 'Soft',
        },
        quantityPosition: {
            label: 'Quantity',
            inline: 'Next to the name',
            right: 'On the right',
        },
        categoryScheme: {
            label: 'Category colors',
            classic: 'Classic',
            deep: 'Deeper',
        },
        macroPreview: {
            label: 'Macro preview',
            card: 'Card',
            compact: 'Compact',
        },
    },
    dayNotes: {
        menuLabel: 'Day notes',
        deleteMenuLabel: 'Delete day notes',
        modalTitle: 'Day notes',
        placeholder: 'Write notes for this day...',
        charLimit: '{count}/300 characters',
        unsavedTitle: 'Unsaved changes',
        unsavedBody: 'You have unsaved changes. Do you want to discard them?',
        discardChanges: 'Discard',
    },
}
